module.exports = __webpack_public_path__ + "static/ube-bread-177bc2be199b5790da8c88eb3541af63.jpg";